import { ChangeDetectionStrategy, Component } from '@angular/core';

import { UserService } from '../../../services/user.service';
import { IconTypes } from '../../../standalones/components/pencil-icon/pencil-icon.component';

/**
 * "Language" item with its submenu, for use inside a parent mat-menu.
 * Lives in its own component so the parent menu doesn't register it for hover,
 * which keeps the submenu click-only like the other pencil-mat-menu submenus.
 */
@Component({
  selector: 'app-language-submenu-item',
  templateUrl: './language-submenu-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageSubmenuItemComponent {
  rtl$ = this.userService.rtl;
  readonly IconTypes = IconTypes;

  constructor(private userService: UserService) {}
}
